// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Global variables adn mixins are defined here */
::ng-deep .cdk-global-scrollblock {
  overflow: hidden;
}

::ng-deep mat-pseudo-checkbox {
  width: 0px !important;
}

::ng-deep .mat-mdc-dialog-container .mdc-dialog__surface {
  width: auto !important;
}

::ng-deep .mdc-list-item__primary-text {
  margin: 0px !important;
}

::ng-deep .mdc-tab__ripple {
  display: none;
}

::ng-deep .mdc-checkbox .mdc-checkbox__native-control:enabled:checked ~ .mdc-checkbox__background,
.mdc-checkbox .mdc-checkbox__native-control:enabled:indeterminate ~ .mdc-checkbox__background,
.mdc-checkbox .mdc-checkbox__native-control[data-indeterminate=true]:enabled ~ .mdc-checkbox__background {
  background-color: #3e97ff !important;
  border-color: #3e97ff !important;
}

.toaster {
  background-color: #f4f7ff !important;
}

/* variables */
/* MIXINS */
/* mixin for border radius */
/* To create a section at the center of window */
/* To include and adjust background image */
/* to split the input */
/* box-shadow generator
    \$clr- in RGBA format
 */
/*
remove the autofilled background color
*/
/* mixin for create buttons */
/* generate margin & padding */
/* to set the table row */
/* to set the image */
/* to set the styles for first and last child div */
/* to set the font style */
.ast-table .table {
  margin-bottom: 0px;
}
.ast-table table thead th {
  background-color: #edeced;
  border: 1px solid #dee2e6;
  border-top: none !important;
}
.ast-table table td {
  background-color: #fafafa;
  color: #231f20;
  border: 0.5px solid #e2e2e1;
  font-size: 16px;
  font-weight: 500;
  font-family: "Amazon Ember Display Light";
}

/* To create a card at the center */
::ng-deep mat-pseudo-checkbox {
  display: none !important;
}

::ng-deep .mat-calendar-body-selected {
  background-color: #3e97ff !important;
}

::ng-deep .mdc-text-field--filled:not(.mdc-text-field--disabled) .mdc-line-ripple::after {
  border-bottom: none !important;
}

::ng-deep .mdc-text-field--filled:not(.mdc-text-field--disabled) .mdc-line-ripple::before {
  border-bottom: none !important;
}

::ng-deep .mat-mdc-form-field-has-icon-suffix .mat-mdc-text-field-wrapper {
  background-color: #f2f4ff !important;
}

::ng-deep .mat-form-field {
  border: none !important;
}

.dateselect mat-form-field {
  display: flex;
  height: 25px;
  width: 185px;
  font-size: 12px;
  text-align: center;
  height: 24px;
  font-family: "Poppins", sans-serif;
  font-weight: 500;
  margin-top: 7px;
  margin-left: 8px;
}
.dateselect mat-form-field mat-date-range-input {
  color: #959cbd !important;
  display: flex;
  justify-self: center;
}
.dateselect mat-form-field mat-date-range-input ::ng-deep .mat-date-range-input-separator {
  color: #959cbd !important;
}
.dateselect mat-form-field ::ng-deep .mat-date-range-input-content {
  border-bottom: none !important;
}
.dateselect mat-form-field mat-label {
  font-size: 12px;
}
.dateselect mat-form-field ::ng-deep mat-datepicker-toggle {
  background-image: url('calendar-icon.svg');
  background-repeat: no-repeat;
}
.dateselect mat-form-field ::ng-deep mat-datepicker-toggle button {
  margin-left: 35px;
  width: 20px !important;
}
.dateselect mat-form-field ::ng-deep mat-datepicker-toggle .mat-mdc-icon-button svg {
  display: none !important;
}

::ng-deep .mat-mdc-form-field-icon-suffix,
[dir=rtl] .mat-mdc-form-field-icon-prefix {
  width: 30px !important;
  margin-top: 10px;
}

::ng-deep .mat-mdc-form-field-has-icon-suffix .mat-mdc-text-field-wrapper {
  align-items: center;
  border-radius: 5px;
}

::ng-deep .mat-mdc-icon-button {
  --mat-icon-button-hover-state-layer-opacity: 0 !important;
}

::ng-deep .mat-mdc-icon-button .mat-mdc-button-persistent-ripple {
  display: none;
}

.tab-header ::ng-deep .mat-mdc-tab-list {
  align-content: center;
}
.tab-header ::ng-deep .mat-mdc-tab-links {
  gap: 5px;
}

/** Date Picker **/
::ng-deep mat-datepicker-toggle {
  width: 0 !important;
}
::ng-deep mat-datepicker-toggle button {
  position: absolute;
  /* margin-bottom: -20px; */
  top: -23% !important;
  right: 40px;
}

.date-picker {
  height: 25px;
  min-width: 180px;
  font-size: 12px;
  text-align: center;
  font-family: "Poppins", sans-serif;
  font-weight: 500;
  margin: 7px 0;
}
.date-picker mat-form-field {
  width: 210px;
}
.date-picker ::ng-deep .mdc-text-field {
  padding-left: 0 !important;
}
.date-picker ::ng-deep .mdc-text-field .mat-mdc-form-field-flex .mat-mdc-form-field-infix {
  padding: 0 !important;
}
.date-picker ::ng-deep .mdc-text-field .mat-mdc-form-field-flex {
  height: 23px;
}
.date-picker ::ng-deep .mdc-text-field .mat-mdc-form-field-flex .mat-mdc-form-field-icon-suffix {
  width: 0 !important;
  padding: 0 !important;
  margin: 0 !important;
}
.date-picker mat-date-range-input {
  color: #959cbd !important;
  display: flex;
  justify-self: center;
}
.date-picker mat-date-range-input ::ng-deep .mat-date-range-input-separator {
  color: #959cbd !important;
}
.date-picker mat-date-range-input ::ng-deep .mat-date-range-input-inner {
  letter-spacing: 0.5px;
}
.date-picker mat-date-range-input ::ng-deep .mat-date-range-input-container {
  justify-content: center;
  font-family: "Poppins";
  width: -moz-fit-content;
  width: fit-content;
  margin: 0 10px;
}
.date-picker mat-date-range-input ::ng-deep .mat-date-range-input-content {
  border-bottom: none !important;
}
.date-picker mat-date-range-input ::ng-deep .mat-date-range-input-end-wrapper {
  flex-grow: initial !important;
}
.date-picker mat-date-range-input ::ng-deep .mat-date-range-input-wrapper {
  width: 70px;
}
.date-picker mat-label {
  font-size: 12px;
}
.date-picker ::ng-deep mat-datepicker-toggle button {
  width: 24px !important;
  height: 24px !important;
  padding: 0 !important;
  transform: translateX(10px);
  background-image: url('calendar-icon.svg');
  background-repeat: no-repeat;
  background-position: center;
}
.date-picker ::ng-deep mat-datepicker-toggle .mat-mdc-icon-button svg {
  display: none !important;
}

/** Date Picker **/
.back-button,
.close-button {
  width: 35px;
  height: 35px;
  background-position: center;
  background-repeat: no-repeat;
  cursor: pointer;
  transition: all 0.25s;
}

.back-button {
  background-image: url('back.svg');
}
.back-button:hover {
  background-image: url('back-hover.svg');
}

.close-button {
  background-image: url('close-circle.svg');
}
.close-button:hover {
  background-image: url('close-cirlce-hover.svg');
}

::ng-deep .mat-mdc-dialog-container .mdc-dialog__surface {
  width: auto !important;
  height: auto !important;
}

.table-responsive {
  margin-top: 10px;
  box-shadow: none;
}
.table-responsive table {
  font-family: "Poppins" !important;
  box-shadow: none;
  border: none;
}
.table-responsive table thead tr th {
  font-size: 12px;
  color: #959cbd;
  border-bottom: none;
  vertical-align: middle;
  letter-spacing: 1px;
}
.table-responsive table thead tr .action {
  text-align: center;
}
.table-responsive table tbody tr td {
  border-bottom: 1px solid #e1e3ea;
  min-width: 100px;
  vertical-align: middle;
  font-size: 13px;
}
.table-responsive table tbody tr td .name-icon {
  position: relative;
}
.table-responsive table tbody tr td .name-icon img {
  position: absolute;
  width: 30%;
}
.table-responsive table tbody tr td .name-icon .prof {
  color: #3e97ff;
  text-transform: uppercase;
  cursor: pointer;
  border-right: 1px solid #f3f3f3;
  border-top: 1px solid #f3f3f3;
  border-bottom: 1px solid #f3f3f3;
  border-left: 1px solid #f3f3f3;
  background-color: #f3f3f3;
  border-radius: 3px;
  padding: 6px 12px;
  font-size: 18px;
  text-align: center;
  margin-right: 10px;
  min-width: 40px;
  max-width: 40px;
}
.table-responsive table tbody tr td .name {
  font-weight: 600;
}
.table-responsive table tbody tr td .flex {
  font-weight: 500;
  font-weight: 600;
}
.table-responsive table tbody tr td .user-des .mobile {
  color: #959cbd;
  font-weight: 500;
}
.table-responsive table tbody tr td .site-name {
  color: #959cbd;
  font-weight: 500;
}
.table-responsive table tbody tr td .download {
  width: 121px;
  font-size: 12px;
  border: none;
  padding: 10px;
  border-radius: 5px;
}
.table-responsive table tbody tr td .download:hover {
  color: #3e97ff;
  background-color: #f2f4ff;
}
.table-responsive table tbody tr td .download .icon-edit {
  margin-right: 8px;
}
.table-responsive table tbody tr td .download .view {
  font-weight: 600;
}

p-table {
  font-family: "Poppins" !important;
  box-shadow: none;
  border: none;
}
p-table tr th {
  font-size: 12px;
  color: #959cbd;
  border-bottom: none;
  vertical-align: middle;
  letter-spacing: 1px;
}
p-table tr .action {
  text-align: center;
}
p-table tr td {
  border-bottom: 1px solid #e1e3ea;
  min-width: 100px;
  vertical-align: middle;
  font-size: 13px;
}
p-table tr td .name-icon {
  position: relative;
}
p-table tr td .name-icon img {
  position: absolute;
  width: 30%;
}
p-table tr td .name-icon .prof {
  color: #3e97ff;
  text-transform: uppercase;
  cursor: pointer;
  border-right: 1px solid #f3f3f3;
  border-top: 1px solid #f3f3f3;
  border-bottom: 1px solid #f3f3f3;
  border-left: 1px solid #f3f3f3;
  background-color: #f3f3f3;
  border-radius: 3px;
  padding: 6px 12px;
  font-size: 18px;
  text-align: center;
  margin-right: 10px;
  min-width: 40px;
  max-width: 40px;
}
p-table tr td .name {
  font-weight: 600;
}
p-table tr td .flex {
  font-weight: 500;
  font-weight: 600;
}
p-table tr td .user-des .mobile {
  color: #959cbd;
  font-weight: 500;
}
p-table tr td .site-name {
  color: #959cbd;
  font-weight: 500;
}
p-table tr td .download {
  width: 121px;
  font-size: 12px;
  border: none;
  padding: 10px;
  border-radius: 5px;
}
p-table tr td .download:hover {
  color: #3e97ff;
  background-color: #f2f4ff;
}
p-table tr td .download .icon-edit {
  margin-right: 8px;
}
p-table tr td .download .view {
  font-weight: 600;
}

.card {
  background-color: none;
  border: none;
  margin-top: 20px;
}

p-table ::ng-deep .p-datatable .p-datatable-header {
  background: none !important;
  border: none !important;
  padding: 20px 0px;
  padding-top: 0px;
  position: absolute;
  width: 100%;
  margin-top: -65px;
}
p-table th,
p-table td {
  font-family: "Poppins";
}

::ng-deep .dataTables_filter label {
  margin: 15px !important;
  font-size: 15px !important;
}
::ng-deep .dataTables_filter label :focus {
  border: none !important;
}

.action {
  text-align: left !important;
}

.action-btns {
  color: #50cd89 !important;
  border: none !important;
  background: none !important;
}
.action-btns i {
  font-size: 13px;
}

.reject {
  color: #ff4b55 !important;
}

.sno {
  text-align: left !important;
}

.trash {
  width: 15px;
  height: 12px;
}

.searchClass {
  display: flex;
  justify-content: flex-end;
}

.searchText {
  display: flex;
  align-items: center;
  width: 25%;
  border: 1px solid #e1e3ea;
  border-radius: 5px;
}
.searchText input {
  border: none;
  font-size: 12px;
  font-family: "Poppins" !important;
}
.searchText :focus {
  box-shadow: none !important;
}

.searchImg {
  width: 20px;
  height: 15px;
  padding-left: 5px;
}

::ng-deep .dataTables_info {
  font-size: 15px !important;
}

::ng-deep .dataTables_length label {
  font-size: 15px !important;
  margin-top: 15px !important;
}

::ng-deep .dataTables_wrapper .dataTables_paginate .paginate_button.current,
.dataTables_wrapper .dataTables_paginate .paginate_button.current:hover {
  padding: 0px !important;
}

.approvals-container {
  font-family: "Poppins" !important;
  background-color: #ffffff;
  padding: 10px;
}
.approvals-container ::ng-deep .mat-card-subtitle,
.approvals-container .mat-card-content {
  font-size: 12px;
}
.approvals-container ::ng-deep .mat-card-subtitle ::ng-deep .dataTables_wrapper .dataTables_filter input,
.approvals-container .mat-card-content ::ng-deep .dataTables_wrapper .dataTables_filter input {
  outline: none;
}
.approvals-container .approval-header {
  margin-bottom: 20px;
}
.approvals-container .approval-header .layout-header .vendor-txt .back-icon i {
  margin-right: 20px;
  font-weight: 500;
  font-size: 18px;
  cursor: pointer;
}
.approvals-container .approval-header .layout-header .vendor-txt .approval-txt {
  font-size: 18px;
  font-weight: 500;
}
.approvals-container .approval-header .vendor-filter {
  font-size: 12px;
  margin: auto 0px auto auto;
}
.approvals-container .approval-header .vendor-filter select {
  padding: 5px;
  border: 1px solid #707070;
  border-radius: 5px;
  background-color: #ffffff;
  outline: none;
}
.approvals-container .dashboard-card-content {
  box-shadow: none;
}
.approvals-container .dashboard-card-content table {
  border: 1px solid #ddd;
}
.approvals-container .dashboard-card-content table thead th {
  color: #707070;
  vertical-align: middle;
  min-width: 100px;
  border-bottom: none;
}
.approvals-container .dashboard-card-content table tbody .name-icon .prof {
  color: #3e97ff;
  text-transform: uppercase;
  cursor: pointer;
  border-right: 10px solid #f3f3f3;
  border-top: 5px solid #f3f3f3;
  border-bottom: 5px solid #f3f3f3;
  border-left: 10px solid #f3f3f3;
  background-color: #f3f3f3;
  border-radius: 3px;
  font-size: 15px;
  text-align: center;
}
.approvals-container .dashboard-card-content table tbody .no-user {
  font-size: 12px;
  color: #707070;
}
.approvals-container .dashboard-card-content table tbody .user-des {
  margin-left: 20px;
}
.approvals-container .dashboard-card-content table tbody .user-des .name {
  font-weight: 500;
  color: #595a5c;
}
.approvals-container .dashboard-card-content table tbody .user-des .name::first-letter {
  text-transform: uppercase;
}
.approvals-container .dashboard-card-content table tbody .user-des .mobile {
  margin-top: 3px;
  color: #707070;
  font-size: 12px;
}
.approvals-container .dashboard-card-content table tbody .site-security {
  font-weight: 500;
  color: #595a5c;
}
.approvals-container .dashboard-card-content table tbody .vendor {
  font-weight: normal;
  color: #707070;
}
.approvals-container .dashboard-card-content table tbody .role {
  margin-top: 3px;
  color: #707070;
  font-size: 12px;
}
.approvals-container .dashboard-card-content table tbody .fname,
.approvals-container .dashboard-card-content table tbody .lname,
.approvals-container .dashboard-card-content table tbody .mobileno,
.approvals-container .dashboard-card-content table tbody .vendorname,
.approvals-container .dashboard-card-content table tbody .rolename {
  font-size: 14px;
  color: #707070;
}
.approvals-container .dashboard-card-content table tbody .orange-flag {
  color: #fd7e14;
}
.approvals-container .dashboard-card-content table tbody .red-flag {
  color: #dc3545;
}
.approvals-container .dashboard-card-content table tbody .action .action-btns {
  background-color: #ffffff;
  border: none;
  margin-right: 5px;
}
.approvals-container .dashboard-card-content table tbody .action .action-btns .fa-check {
  color: #50cd89;
  padding: 5px;
  border-radius: 3px;
  cursor: pointer;
  border: 1px solid #f3f3f3;
  background-color: #f3f3f3;
}
.approvals-container .dashboard-card-content table tbody .action .action-btns .fa-trash {
  color: #ff0000;
  padding: 5px;
  border-radius: 3px;
  cursor: pointer;
  border: 1px solid #f3f3f3;
  background-color: #f3f3f3;
}

@media screen and (max-width: 992px) {
  .approvals-container .dashboard-card-content table tbody .action .action-btns {
    margin-right: 0px;
  }
  .approvals-container .my-pagination {
    margin-bottom: 10px;
  }
}
@media screen and (max-width: 767px) {
  .searchText {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/global.scss","webpack://./src/app/bas/dashboard/approvals-v2/approvals-v2.component.scss","webpack://./src/assets/styles/reuseStyle.scss"],"names":[],"mappings":"AAAA,iDAAA;AAEA;EACE,gBAAA;ACAF;;ADGA;EACE,qBAAA;ACAF;;ADGA;EACE,sBAAA;ACAF;;ADQA;EACE,sBAAA;ACLF;;ADQA;EACE,aAAA;ACLF;;ADQA;;;EAGE,oCAAA;EACA,gCAAA;ACLF;;ADQA;EACE,oCAAA;ACLF;;ADQA,cAAA;AAmDA,WAAA;AAEA,4BAAA;AAcA,gDAAA;AAuBA,2CAAA;AAaA,uBAAA;AAgBA;;EAAA;AAUA;;CAAA;AAcA,6BAAA;AAoEA,8BAAA;AASA,yBAAA;AAuBA,qBAAA;AAQA,mDAAA;AAaA,0BAAA;AAmBE;EACE,kBAAA;AC9QJ;ADsRM;EACE,yBAAA;EACA,yBAAA;EACA,2BAAA;ACpRR;ADwRI;EAtEF,yBAwE2B;EAvE3B,cAuEoC;EAtEpC,2BAsE6C;EArE7C,eAqEkE;EAnElE,gBAAA;EACA,yCAAA;AChNF;;ADuRA,mCAAA;AA8BA;EACE,wBAAA;ACjTF;;ADoTA;EACE,oCAAA;ACjTF;;ADoTA;EACE,8BAAA;ACjTF;;ADoTA;EACE,8BAAA;ACjTF;;ADoTA;EACE,oCAAA;ACjTF;;ADoTA;EACE,uBAAA;ACjTF;;ADqTE;EACE,aAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;EACA,kCAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AClTJ;ADoTI;EAKE,yBAAA;EACA,aAAA;EACA,oBAAA;ACtTN;ADgTM;EACE,yBAAA;AC9SR;ADsTI;EACE,8BAAA;ACpTN;ADuTI;EACE,eAAA;ACrTN;ADwTI;EACE,0CAAA;EACA,4BAAA;ACtTN;ADwTM;EACE,iBAAA;EACA,sBAAA;ACtTR;ADyTM;EACE,wBAAA;ACvTR;;AD6TA;;EAEE,sBAAA;EACA,gBAAA;AC1TF;;AD6TA;EACE,mBAAA;EACA,kBAAA;AC1TF;;AD6TA;EACE,yDAAA;AC1TF;;AD6TA;EACE,aAAA;AC1TF;;AD8TE;EACE,qBAAA;AC3TJ;AD8TE;EACE,QAAA;AC5TJ;;ADiUA,kBAAA;AAEA;EACE,mBAAA;AC/TF;ADiUE;EACE,kBAAA;EACA,0BAAA;EACA,oBAAA;EACA,WAAA;AC/TJ;;ADmUA;EACE,YAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,kCAAA;EACA,gBAAA;EACA,aAAA;AChUF;ADkUE;EACE,YAAA;AChUJ;ADmUE;EACE,0BAAA;ACjUJ;ADoUE;EACE,qBAAA;AClUJ;ADqUE;EACE,YAAA;ACnUJ;ADsUE;EACE,mBAAA;EACA,qBAAA;EACA,oBAAA;ACpUJ;ADuUE;EACE,yBAAA;EACA,aAAA;EACA,oBAAA;ACrUJ;ADuUI;EACE,yBAAA;ACrUN;ADyUI;EACE,qBAAA;ACvUN;AD0UI;EACE,uBAAA;EACA,sBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,cAAA;ACxUN;AD2UI;EACE,8BAAA;ACzUN;AD4UI;EACE,6BAAA;AC1UN;AD6UI;EACE,WAAA;AC3UN;AD+UE;EACE,eAAA;AC7UJ;ADiVI;EACE,sBAAA;EACA,uBAAA;EACA,qBAAA;EACA,2BAAA;EACA,0CAAA;EACA,4BAAA;EACA,2BAAA;AC/UN;ADkVI;EACE,wBAAA;AChVN;;ADqVA,kBAAA;AAGA;;EAEE,WAAA;EACA,YAAA;EACA,2BAAA;EACA,4BAAA;EACA,eAAA;EACA,qBAAA;ACpVF;;ADuVA;EACE,iCAAA;ACpVF;ADsVE;EACE,uCAAA;ACpVJ;;ADwVA;EACE,yCAAA;ACrVF;ADuVE;EACE,+CAAA;ACrVJ;;AClQA;EACE,sBAAA;EACA,uBAAA;ADqQF;;AClQA;EAEE,gBAAA;EACA,gBAAA;ADoQF;ACnQE;EACE,iCAAA;EACA,gBAAA;EACA,YAAA;ADqQJ;AClQQ;EACE,eAAA;EACA,cF6CC;EE5CD,mBAAA;EACA,sBAAA;EACA,mBAAA;ADoQV;AClQQ;EACE,kBAAA;ADoQV;AC9PQ;EACE,gCAAA;EACA,gBAAA;EACA,sBAAA;EACA,eAAA;ADgQV;AC9PU;EACE,kBAAA;ADgQZ;AC/PY;EACE,kBAAA;EACA,UAAA;ADiQd;AC/PY;EACE,cFFJ;EEGI,yBAAA;EACA,eAAA;EACA,+BAAA;EACA,6BAAA;EACA,gCAAA;EACA,8BAAA;EACA,yBFwBL;EEvBK,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;ADiQd;AC9PU;EACE,gBAAA;ADgQZ;AC9PU;EACE,gBAAA;EACA,gBAAA;ADgQZ;AC5PY;EACE,cFPH;EEQG,gBAAA;AD8Pd;AC3PU;EACE,cFZD;EEaC,gBAAA;AD6PZ;AC3PU;EACE,YAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;AD6PZ;AC5PY;EACE,cF5CJ;EE6CI,yBF3CE;ACyShB;AC5PY;EACE,iBAAA;AD8Pd;AC5PY;EACE,gBAAA;AD8Pd;;ACrPA;EACE,iCAAA;EACA,gBAAA;EACA,YAAA;ADwPF;ACtPI;EACE,eAAA;EACA,cF7CK;EE8CL,mBAAA;EACA,sBAAA;EACA,mBAAA;ADwPN;ACtPI;EACE,kBAAA;ADwPN;ACpPI;EACE,gCAAA;EACA,gBAAA;EACA,sBAAA;EACA,eAAA;ADsPN;ACpPM;EACE,kBAAA;ADsPR;ACrPQ;EACE,kBAAA;EACA,UAAA;ADuPV;ACrPQ;EACE,cF1FA;EE2FA,yBAAA;EACA,eAAA;EACA,+BAAA;EACA,6BAAA;EACA,gCAAA;EACA,8BAAA;EACA,yBFhED;EEiEC,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;ADuPV;ACpPM;EACE,gBAAA;ADsPR;ACpPM;EACE,gBAAA;EACA,gBAAA;ADsPR;AClPQ;EACE,cF/FC;EEgGD,gBAAA;ADoPV;ACjPM;EACE,cFpGG;EEqGH,gBAAA;ADmPR;ACjPM;EACE,YAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;ADmPR;AClPQ;EACE,cFpIA;EEqIA,yBFnIM;ACuXhB;AClPQ;EACE,iBAAA;ADoPV;AClPQ;EACE,gBAAA;ADoPV;;AApaA;EACE,sBAAA;EACA,YAAA;EACA,gBAAA;AAuaF;;AAnaE;EACE,2BAAA;EACA,uBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,iBAAA;AAsaJ;AAnaE;;EAEE,sBAAA;AAqaJ;;AAhaE;EACE,uBAAA;EACA,0BAAA;AAmaJ;AAjaI;EACE,uBAAA;AAmaN;;AA9ZA;EACE,2BAAA;AAiaF;;AA9ZA;EACE,yBAAA;EACA,uBAAA;EACA,2BAAA;AAiaF;AA/ZE;EACE,eAAA;AAiaJ;;AA7ZA;EACE,yBAAA;AAgaF;;AA7ZA;EACE,2BAAA;AAgaF;;AA7ZA;EACE,WAAA;EACA,YAAA;AAgaF;;AA7ZA;EACE,aAAA;EACA,yBAAA;AAgaF;;AA7ZA;EACE,aAAA;EACA,mBAAA;EACA,UAAA;EACA,yBAAA;EACA,kBAAA;AAgaF;AA9ZE;EACE,YAAA;EACA,eAAA;EACA,iCAAA;AAgaJ;AA7ZE;EACE,2BAAA;AA+ZJ;;AA3ZA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AA8ZF;;AA3ZA;EACE,0BAAA;AA8ZF;;AA1ZE;EACE,0BAAA;EACA,2BAAA;AA6ZJ;;AAzZA;;EAEE,uBAAA;AA4ZF;;AAzZA;EACE,iCAAA;EACA,yBAAA;EACA,aAAA;AA4ZF;AA1ZE;;EAEE,eAAA;AA4ZJ;AA1ZI;;EACE,aAAA;AA6ZN;AAzZE;EACE,mBAAA;AA2ZJ;AAtZU;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;AAwZZ;AApZQ;EACE,eAAA;EACA,gBAAA;AAsZV;AAjZI;EACE,eAAA;EACA,0BAAA;AAmZN;AAjZM;EACE,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;EACA,aAAA;AAmZR;AA9YE;EACE,gBAAA;AAgZJ;AA9YI;EACE,sBAAA;AAgZN;AA7YQ;EACE,cD1FK;EC2FL,sBAAA;EACA,gBAAA;EACA,mBAAA;AA+YV;AAzYU;EACE,cDzGE;EC0GF,yBAAA;EACA,eAAA;EACA,gCAAA;EACA,6BAAA;EACA,gCAAA;EACA,+BAAA;EACA,yBD9GH;EC+GG,kBAAA;EACA,eAAA;EACA,kBAAA;AA2YZ;AAvYQ;EACE,eAAA;EACA,cDpHK;AC6ff;AAtYQ;EACE,iBAAA;AAwYV;AAtYU;EACE,gBAAA;EACA,cD7HK;ACqgBjB;AArYU;EACE,yBAAA;AAuYZ;AApYU;EACE,eAAA;EACA,cDrIG;ECsIH,eAAA;AAsYZ;AAlYQ;EACE,gBAAA;EACA,cD7IO;ACihBjB;AAjYQ;EACE,mBAAA;EACA,cDjJK;ACohBf;AAhYQ;EACE,eAAA;EACA,cDtJK;ECuJL,eAAA;AAkYV;AA/XQ;;;;;EAKE,eAAA;EACA,cDhKK;ACiiBf;AA9XQ;EACE,cAAA;AAgYV;AA7XQ;EACE,cAAA;AA+XV;AA3XU;EACE,yBD5KJ;EC6KI,YAAA;EACA,iBAAA;AA6XZ;AA3XY;EACE,cDnNJ;ECoNI,YAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,yBD1LL;ACujBT;AA1XY;EACE,cDvLJ;ECwLI,YAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,yBDnML;AC+jBT;;AAnXA;EAMY;IACE,iBAAA;EAiXZ;EA1WE;IACE,mBAAA;EA4WJ;AACF;AAxWA;EACE;IACE,WAAA;EA0WF;AACF","sourcesContent":["/* Global variables adn mixins are defined here */\n\n::ng-deep .cdk-global-scrollblock {\n  overflow: hidden;\n}\n\n::ng-deep mat-pseudo-checkbox {\n  width: 0px !important;\n}\n\n::ng-deep .mat-mdc-dialog-container .mdc-dialog__surface {\n  width: auto !important;\n  // height: auto !important;\n}\n\n// ::ng-deep mat-option{\n//     display: flex !important;\n//     justify-content: center !important;\n// }\n::ng-deep .mdc-list-item__primary-text {\n  margin: 0px !important;\n}\n\n::ng-deep .mdc-tab__ripple {\n  display: none;\n}\n\n::ng-deep .mdc-checkbox .mdc-checkbox__native-control:enabled:checked~.mdc-checkbox__background,\n.mdc-checkbox .mdc-checkbox__native-control:enabled:indeterminate~.mdc-checkbox__background,\n.mdc-checkbox .mdc-checkbox__native-control[data-indeterminate=\"true\"]:enabled~.mdc-checkbox__background {\n  background-color: #3e97ff !important;\n  border-color: #3e97ff !important;\n}\n\n.toaster {\n  background-color: #f4f7ff !important;\n}\n\n/* variables */\n\n$primary: #3e97ff;\n$primary-active: #2884ef;\n$primary-light: #f2f4ff;\n$success: #50cd89;\n$success-active: #50cd89;\n$success-light: #e8fff3;\n$danger: #ff4b55;\n$danger-active: #d9214e;\n$danger-light: #fff5f8;\n$info: #7dcfdb;\n$info-active: #4fc9da;\n$info-light: #edf9fb;\n$warning: #ffa800;\n$warning-active: #ffa800;\n$warning-light: #fff7e7;\n$white: #ffffff;\n$white-active: #f5f8fa;\n$dark: #181c32;\n$gray-100: #f9f9f9;\n$gray-200: #f1f1f2;\n$gray-300: #e1e3ea;\n$gray-400: #d8d8e5;\n$gray-500: #959cbd;\n$gray-600: #7e8299;\n$gray-700: #5e6278;\n$gray-800: #3f4254;\n$gray-900: #181c32;\n$gray-button: #1e2238;\n\n//\n$primary-clr-dark: #232f3e;\n$primary-clr: #3e97ff;\n$primary-clr-alpha: #00a8e1;\n$bg-clr: #f3f3f3;\n$bg-clr-alpha: #edeced;\n$primary-ft-clr: #595a5c;\n$primary-grey: #707070;\n$white: #ffffff;\n$black: #3f4254;\n// $success: #347439;\n$failure: #ff0000;\n$grey: #cccccc;\n$primary-font: \"Poppins\", sans-serif;\n$ft-thin: 300;\n$ft-regular: 400;\n$ft-500: 500;\n$ft-bold: 700;\n$ft-semibold: 600;\n\n/* MIXINS */\n\n/* mixin for border radius */\n\n@mixin border-radius($top, $right, $bottom, $left) {\n  -webkit-border-radius: $top $right $bottom $left;\n  -moz-border-radius: $top $right $bottom $left;\n  border-radius: $top $right $bottom $left;\n}\n\n@mixin border-single-radius($rad) {\n  -webkit-border-radius: $rad;\n  -moz-border-radius: $rad;\n  border-radius: $rad;\n}\n\n/* To create a section at the center of window */\n@mixin create-centered-section($width,\n  $border-radius,\n  $padding-tb,\n  $padding-lr,\n  $border,\n  $background,\n  $left) {\n  position: absolute;\n  margin: auto;\n  top: 0;\n  left: $left;\n  right: 0;\n  bottom: 0;\n  width: $width;\n  height: 50vh;\n  // max-height: 520px;\n  border-radius: $border-radius;\n  padding: $padding-tb $padding-lr;\n  border: $border;\n  background: $background;\n}\n\n/* To include and adjust background image */\n@mixin set-background-image($bg-color,\n  $bg-url,\n  $bg-position,\n  $bg-repeat,\n  $bg-size) {\n  background: $bg-color;\n  background-image: $bg-url;\n  background-position: $bg-position;\n  background-repeat: $bg-repeat;\n  background-size: $bg-size;\n}\n\n/* to split the input */\n@mixin split-input($ltr-space,\n  $bg-img,\n  $bg-position,\n  $bg-size,\n  $bg-repeat,\n  $bg-pos-x) {\n  border: 0;\n  letter-spacing: $ltr-space;\n  background-image: $bg-img;\n  background-position: bottom;\n  background-size: $bg-size;\n  background-repeat: $bg-repeat;\n  background-position-x: $bg-pos-x;\n}\n\n/* box-shadow generator\n    $clr- in RGBA format\n */\n\n@mixin box-shadows($hset, $vset, $blur, $spread, $clr) {\n  -webkit-box-shadow: $hset $vset $blur $spread $clr;\n  -moz-box-shadow: $hset $vset $blur $spread $clr;\n  box-shadow: $hset $vset $blur $spread $clr;\n}\n\n/*\nremove the autofilled background color\n*/\n@mixin remove-autofill-background() {\n\n  input:-webkit-autofill,\n  input:-webkit-autofill:hover,\n  input:-webkit-autofill:focus,\n  input:-webkit-autofill:active {\n    transition-delay: 99999s;\n    -webkit-transition-delay: 99999s;\n  }\n}\n\n/* mixin for create buttons */\n\n@mixin create-buttons($bgClr,\n  $clr,\n  $ptb,\n  $plr,\n  $width,\n  $height,\n  $ft-size,\n  $ft-weight,\n  $rad) {\n  display: inline-block;\n  // padding: $ptb $plr;\n  margin-bottom: 0;\n  line-height: calc($height/2);\n  text-align: left;\n  white-space: nowrap;\n  vertical-align: middle;\n  -ms-touch-action: manipulation;\n  touch-action: manipulation;\n  cursor: pointer;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  background-image: none;\n  border: 1px solid transparent;\n  @include border-single-radius($rad);\n  font-size: $ft-size;\n  font-weight: $ft-weight;\n  height: $height;\n  min-width: $width;\n  background: $bgClr;\n  color: $clr;\n  position: relative;\n  text-align: center;\n\n  &:disabled {\n    cursor: not-allowed;\n  }\n\n  &:focus {\n    outline: none;\n  }\n\n  &:hover,\n  &:focus,\n  &:active {\n    // background: $clr;\n    // color: $bgClr;\n    // border: 1px solid $bgClr;\n    transition-duration: 0.5s;\n    transition-timing-function: ease-in-out;\n    text-decoration: none;\n  }\n}\n\n@mixin no-transition($bg-color, $color) {\n\n  &:hover,\n  &:focus,\n  &:active {\n    background: $bg-color;\n    color: $color;\n    border: 1px solid $bg-color;\n  }\n}\n\n/* generate margin & padding */\n@mixin generate-margin($tp, $rt, $bt, $lt) {\n  margin: $tp $rt $bt $lt;\n}\n\n@mixin generate-padding($tp, $rt, $bt, $lt) {\n  padding: $tp $rt $bt $lt;\n}\n\n/* to set the table row */\n@mixin set-table-row($bg-color,\n  $color,\n  $border,\n  $font-size,\n  $font-weight,\n  $fontFamily: \"\"\n\n) {\n  background-color: $bg-color;\n  color: $color;\n  border: $border;\n  font-size: $font-size;\n  // font-weight: $font-weight;\n  font-weight: 500;\n  font-family: \"Amazon Ember Display Light\";\n\n  @if $fontFamily !=\"\" {\n    font-family: $fontFamily;\n    font-weight: $font-weight;\n  }\n}\n\n/* to set the image */\n@mixin set-image-config($width, $height, $cursor, $margin-right) {\n  width: $width;\n  height: $height;\n  cursor: $cursor;\n  margin-right: $margin-right;\n}\n\n/* to set the styles for first and last child div */\n@mixin set-child-div($color1, $font-size1, $font-weight1, $color2) {\n  div:first-child {\n    color: $color1;\n    font-size: $font-size1;\n    font-weight: $font-weight1;\n  }\n\n  div:last-child {\n    color: $color2;\n  }\n}\n\n/* to set the font style */\n@mixin set-font-config($fontSize,\n  $fontWeight,\n  $fontColor,\n  $textAlign,\n  $fontFamily: \"\"\n\n) {\n  font-size: $fontSize;\n  font-weight: $fontWeight;\n  color: $fontColor;\n  text-align: $textAlign;\n\n  @if $fontFamily !=\"\" {\n    font-family: $fontFamily;\n  }\n}\n\n.ast-table {\n  .table {\n    margin-bottom: 0px;\n  }\n\n  table {\n    thead {\n\n      // @mixin set-table-row($bg-color, $color, $border, $font-size, $font-weight)\n      // @include set-table-row($white, #231f20, 0.5px solid #e2e2e1, 16px, 300) ;\n      th {\n        background-color: #edeced;\n        border: 1px solid #dee2e6;\n        border-top: none !important;\n      }\n    }\n\n    td {\n      // @mixin set-table-row($bg-color, $color, $border, $font-size, $font-weight)\n      @include set-table-row(#fafafa, #231f20, 0.5px solid #e2e2e1, 16px, 300);\n    }\n  }\n}\n\n/* To create a card at the center */\n@mixin create-card($width,\n  $height,\n  $border-radius,\n  $padding-tb,\n  $padding-lr,\n  $border,\n  $background,\n  $left) {\n  position: relative;\n  margin: auto;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  width: $width;\n  height: $height;\n  border-radius: $border-radius;\n  padding: $padding-tb $padding-lr;\n  border: $border;\n  background: $background;\n  text-align: center;\n}\n\n@mixin flexbox($display, $align-items, $justify-content) {\n  display: $display;\n  align-items: $align-items;\n  justify-content: $justify-content;\n}\n\n::ng-deep mat-pseudo-checkbox {\n  display: none !important;\n}\n\n::ng-deep .mat-calendar-body-selected {\n  background-color: $primary !important;\n}\n\n::ng-deep .mdc-text-field--filled:not(.mdc-text-field--disabled) .mdc-line-ripple::after {\n  border-bottom: none !important;\n}\n\n::ng-deep .mdc-text-field--filled:not(.mdc-text-field--disabled) .mdc-line-ripple::before {\n  border-bottom: none !important;\n}\n\n::ng-deep .mat-mdc-form-field-has-icon-suffix .mat-mdc-text-field-wrapper {\n  background-color: $primary-light !important;\n}\n\n::ng-deep .mat-form-field {\n  border: none !important;\n}\n\n.dateselect {\n  mat-form-field {\n    display: flex;\n    height: 25px;\n    width: 185px;\n    font-size: 12px;\n    text-align: center;\n    height: 24px;\n    font-family: \"Poppins\", sans-serif;\n    font-weight: 500;\n    margin-top: 7px;\n    margin-left: 8px;\n\n    mat-date-range-input {\n      ::ng-deep .mat-date-range-input-separator {\n        color: #959cbd !important;\n      }\n\n      color: #959cbd !important;\n      display: flex;\n      justify-self: center;\n    }\n\n    ::ng-deep .mat-date-range-input-content {\n      border-bottom: none !important;\n    }\n\n    mat-label {\n      font-size: 12px;\n    }\n\n    ::ng-deep mat-datepicker-toggle {\n      background-image: url(../images/calendar-icon.svg);\n      background-repeat: no-repeat;\n\n      button {\n        margin-left: 35px;\n        width: 20px !important;\n      }\n\n      .mat-mdc-icon-button svg {\n        display: none !important;\n      }\n    }\n  }\n}\n\n::ng-deep .mat-mdc-form-field-icon-suffix,\n[dir=\"rtl\"] .mat-mdc-form-field-icon-prefix {\n  width: 30px !important;\n  margin-top: 10px;\n}\n\n::ng-deep .mat-mdc-form-field-has-icon-suffix .mat-mdc-text-field-wrapper {\n  align-items: center;\n  border-radius: 5px;\n}\n\n::ng-deep .mat-mdc-icon-button {\n  --mat-icon-button-hover-state-layer-opacity: 0 !important;\n}\n\n::ng-deep .mat-mdc-icon-button .mat-mdc-button-persistent-ripple {\n  display: none;\n}\n\n.tab-header {\n  ::ng-deep .mat-mdc-tab-list {\n    align-content: center;\n  }\n\n  ::ng-deep .mat-mdc-tab-links {\n    gap: 5px;\n  }\n}\n\n\n/** Date Picker **/\n\n::ng-deep mat-datepicker-toggle {\n  width: 0 !important;\n\n  button {\n    position: absolute;\n    /* margin-bottom: -20px; */\n    top: -23% !important;\n    right: 40px;\n  }\n}\n\n.date-picker {\n  height: 25px;\n  min-width: 180px;\n  font-size: 12px;\n  text-align: center;\n  font-family: \"Poppins\", sans-serif;\n  font-weight: 500;\n  margin: 7px 0;\n\n  mat-form-field {\n    width: 210px;\n  }\n\n  ::ng-deep .mdc-text-field {\n    padding-left: 0 !important;\n  }\n\n  ::ng-deep .mdc-text-field .mat-mdc-form-field-flex .mat-mdc-form-field-infix {\n    padding: 0 !important;\n  }\n\n  ::ng-deep .mdc-text-field .mat-mdc-form-field-flex {\n    height: 23px;\n  }\n\n  ::ng-deep .mdc-text-field .mat-mdc-form-field-flex .mat-mdc-form-field-icon-suffix {\n    width: 0 !important;\n    padding: 0 !important;\n    margin: 0 !important;\n  }\n\n  mat-date-range-input {\n    color: #959cbd !important;\n    display: flex;\n    justify-self: center;\n\n    ::ng-deep .mat-date-range-input-separator {\n      color: #959cbd !important;\n      // margin: 0 10px;\n    }\n\n    ::ng-deep .mat-date-range-input-inner {\n      letter-spacing: 0.5px;\n    }\n\n    ::ng-deep .mat-date-range-input-container {\n      justify-content: center;\n      font-family: \"Poppins\";\n      width: fit-content;\n      margin: 0 10px;\n    }\n\n    ::ng-deep .mat-date-range-input-content {\n      border-bottom: none !important;\n    }\n\n    ::ng-deep .mat-date-range-input-end-wrapper {\n      flex-grow: initial !important;\n    }\n\n    ::ng-deep .mat-date-range-input-wrapper {\n      width: 70px;\n    }\n  }\n\n  mat-label {\n    font-size: 12px;\n  }\n\n  ::ng-deep mat-datepicker-toggle {\n    button {\n      width: 24px !important;\n      height: 24px !important;\n      padding: 0 !important;\n      transform: translateX(10px);\n      background-image: url(../images/calendar-icon.svg);\n      background-repeat: no-repeat;\n      background-position: center;\n    }\n\n    .mat-mdc-icon-button svg {\n      display: none !important;\n    }\n  }\n}\n\n/** Date Picker **/\n\n\n.back-button,\n.close-button {\n  width: 35px;\n  height: 35px;\n  background-position: center;\n  background-repeat: no-repeat;\n  cursor: pointer;\n  transition: all .25s;\n}\n\n.back-button {\n  background-image: url('../images/back.svg');\n\n  &:hover {\n    background-image: url('../images/back-hover.svg');\n  }\n}\n\n.close-button {\n  background-image: url('../images/close-circle.svg');\n\n  &:hover {\n    background-image: url('../images/close-cirlce-hover.svg');\n  }\n}","@import \"src/assets/styles/global.scss\";\n@import \"src/assets/styles/reuseStyle.scss\";\n\n.card {\n  background-color: none;\n  border: none;\n  margin-top: 20px;\n}\n\np-table {\n  ::ng-deep .p-datatable .p-datatable-header {\n    background: none !important;\n    border: none !important;\n    padding: 20px 0px;\n    padding-top: 0px;\n    position: absolute;\n    width: 100%;\n    margin-top: -65px;\n  }\n\n  th,\n  td {\n    font-family: \"Poppins\";\n  }\n}\n\n::ng-deep .dataTables_filter {\n  label {\n    margin: 15px !important;\n    font-size: 15px !important;\n\n    :focus {\n      border: none !important;\n    }\n  }\n}\n\n.action {\n  text-align: left !important;\n}\n\n.action-btns {\n  color: $success !important;\n  border: none !important;\n  background: none !important;\n\n  i {\n    font-size: 13px;\n  }\n}\n\n.reject {\n  color: $danger !important;\n}\n\n.sno {\n  text-align: left !important;\n}\n\n.trash {\n  width: 15px;\n  height: 12px;\n}\n\n.searchClass {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.searchText {\n  display: flex;\n  align-items: center;\n  width: 25%;\n  border: 1px solid $gray-300;\n  border-radius: 5px;\n\n  input {\n    border: none;\n    font-size: 12px;\n    font-family: \"Poppins\" !important;\n  }\n\n  :focus {\n    box-shadow: none !important;\n  }\n}\n\n.searchImg {\n  width: 20px;\n  height: 15px;\n  padding-left: 5px;\n}\n\n::ng-deep .dataTables_info {\n  font-size: 15px !important;\n}\n\n::ng-deep .dataTables_length {\n  label {\n    font-size: 15px !important;\n    margin-top: 15px !important;\n  }\n}\n\n::ng-deep .dataTables_wrapper .dataTables_paginate .paginate_button.current,\n.dataTables_wrapper .dataTables_paginate .paginate_button.current:hover {\n  padding: 0px !important;\n}\n\n.approvals-container {\n  font-family: \"Poppins\" !important;\n  background-color: #ffffff;\n  padding: 10px;\n\n  ::ng-deep .mat-card-subtitle,\n  .mat-card-content {\n    font-size: 12px;\n\n    ::ng-deep .dataTables_wrapper .dataTables_filter input {\n      outline: none;\n    }\n  }\n\n  .approval-header {\n    margin-bottom: 20px;\n\n    .layout-header {\n      .vendor-txt {\n        .back-icon {\n          i {\n            margin-right: 20px;\n            font-weight: 500;\n            font-size: 18px;\n            cursor: pointer;\n          }\n        }\n\n        .approval-txt {\n          font-size: 18px;\n          font-weight: 500;\n        }\n      }\n    }\n\n    .vendor-filter {\n      font-size: 12px;\n      margin: auto 0px auto auto;\n\n      select {\n        padding: 5px;\n        border: 1px solid $primary-grey;\n        border-radius: 5px;\n        background-color: #ffffff;\n        outline: none;\n      }\n    }\n  }\n\n  .dashboard-card-content {\n    box-shadow: none;\n\n    table {\n      border: 1px solid #ddd;\n\n      thead {\n        th {\n          color: $primary-grey;\n          vertical-align: middle;\n          min-width: 100px;\n          border-bottom: none;\n        }\n      }\n\n      tbody {\n        .name-icon {\n          .prof {\n            color: $primary-clr;\n            text-transform: uppercase;\n            cursor: pointer;\n            border-right: 10px solid $bg-clr;\n            border-top: 5px solid $bg-clr;\n            border-bottom: 5px solid $bg-clr;\n            border-left: 10px solid $bg-clr;\n            background-color: $bg-clr;\n            border-radius: 3px;\n            font-size: 15px;\n            text-align: center;\n          }\n        }\n\n        .no-user {\n          font-size: 12px;\n          color: $primary-grey;\n        }\n\n        .user-des {\n          margin-left: 20px;\n\n          .name {\n            font-weight: 500;\n            color: $primary-ft-clr;\n          }\n\n          .name::first-letter {\n            text-transform: uppercase;\n          }\n\n          .mobile {\n            margin-top: 3px;\n            color: $primary-grey;\n            font-size: 12px;\n          }\n        }\n\n        .site-security {\n          font-weight: 500;\n          color: $primary-ft-clr;\n        }\n\n        .vendor {\n          font-weight: normal;\n          color: $primary-grey;\n        }\n\n        .role {\n          margin-top: 3px;\n          color: $primary-grey;\n          font-size: 12px;\n        }\n\n        .fname,\n        .lname,\n        .mobileno,\n        .vendorname,\n        .rolename {\n          font-size: 14px;\n          color: $primary-grey;\n        }\n\n        .orange-flag {\n          color: #fd7e14;\n        }\n\n        .red-flag {\n          color: #dc3545;\n        }\n\n        .action {\n          .action-btns {\n            background-color: $white;\n            border: none;\n            margin-right: 5px;\n\n            .fa-check {\n              color: $success;\n              padding: 5px;\n              border-radius: 3px;\n              cursor: pointer;\n              border: 1px solid $bg-clr;\n              background-color: $bg-clr;\n            }\n\n            .fa-trash {\n              color: $failure;\n              padding: 5px;\n              border-radius: 3px;\n              cursor: pointer;\n              border: 1px solid $bg-clr;\n              background-color: $bg-clr;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n@media screen and (max-width: 992px) {\n  .approvals-container {\n    .dashboard-card-content {\n      table {\n        tbody {\n          .action {\n            .action-btns {\n              margin-right: 0px;\n            }\n          }\n        }\n      }\n    }\n\n    .my-pagination {\n      margin-bottom: 10px;\n    }\n  }\n}\n\n@media screen and (max-width: 767px) {\n  .searchText {\n    width: 100%;\n  }\n}","::ng-deep .mat-mdc-dialog-container .mdc-dialog__surface {\n  width: auto !important;\n  height: auto !important;\n}\n\n.table-responsive {\n  // overflow: scroll;\n  margin-top: 10px;\n  box-shadow: none;\n  table {\n    font-family: \"Poppins\" !important;\n    box-shadow: none;\n    border: none;\n    thead {\n      tr {\n        th {\n          font-size: 12px;\n          color: $gray-500;\n          border-bottom: none;\n          vertical-align: middle;\n          letter-spacing: 1px;\n        }\n        .action {\n          text-align: center;\n        }\n      }\n    }\n    tbody {\n      tr {\n        td {\n          border-bottom: 1px solid $gray-300;\n          min-width: 100px;\n          vertical-align: middle;\n          font-size: 13px;\n\n          .name-icon {\n            position: relative;\n            img {\n              position: absolute;\n              width: 30%;\n            }\n            .prof {\n              color: $primary;\n              text-transform: uppercase;\n              cursor: pointer;\n              border-right: 1px solid $bg-clr;\n              border-top: 1px solid $bg-clr;\n              border-bottom: 1px solid $bg-clr;\n              border-left: 1px solid $bg-clr;\n              background-color: $bg-clr;\n              border-radius: 3px;\n              padding: 6px 12px;\n              font-size: 18px;\n              text-align: center;\n              margin-right: 10px;\n              min-width: 40px;\n              max-width: 40px;\n            }\n          }\n          .name {\n            font-weight: 600;\n          }\n          .flex {\n            font-weight: 500;\n            font-weight: 600;\n          }\n\n          .user-des {\n            .mobile {\n              color: $gray-500;\n              font-weight: 500;\n            }\n          }\n          .site-name {\n            color: $gray-500;\n            font-weight: 500;\n          }\n          .download {\n            width: 121px;\n            font-size: 12px;\n            border: none;\n            padding: 10px;\n            border-radius: 5px;\n            &:hover {\n              color: $primary;\n              background-color: $primary-light;\n            }\n            .icon-edit {\n              margin-right: 8px;\n            }\n            .view {\n              font-weight: 600;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\np-table {\n  font-family: \"Poppins\" !important;\n  box-shadow: none;\n  border: none;\n  tr {\n    th {\n      font-size: 12px;\n      color: $gray-500;\n      border-bottom: none;\n      vertical-align: middle;\n      letter-spacing: 1px;\n    }\n    .action {\n      text-align: center;\n    }\n  }\n  tr {\n    td {\n      border-bottom: 1px solid $gray-300;\n      min-width: 100px;\n      vertical-align: middle;\n      font-size: 13px;\n\n      .name-icon {\n        position: relative;\n        img {\n          position: absolute;\n          width: 30%;\n        }\n        .prof {\n          color: $primary;\n          text-transform: uppercase;\n          cursor: pointer;\n          border-right: 1px solid $bg-clr;\n          border-top: 1px solid $bg-clr;\n          border-bottom: 1px solid $bg-clr;\n          border-left: 1px solid $bg-clr;\n          background-color: $bg-clr;\n          border-radius: 3px;\n          padding: 6px 12px;\n          font-size: 18px;\n          text-align: center;\n          margin-right: 10px;\n          min-width: 40px;\n          max-width: 40px;\n        }\n      }\n      .name {\n        font-weight: 600;\n      }\n      .flex {\n        font-weight: 500;\n        font-weight: 600;\n      }\n\n      .user-des {\n        .mobile {\n          color: $gray-500;\n          font-weight: 500;\n        }\n      }\n      .site-name {\n        color: $gray-500;\n        font-weight: 500;\n      }\n      .download {\n        width: 121px;\n        font-size: 12px;\n        border: none;\n        padding: 10px;\n        border-radius: 5px;\n        &:hover {\n          color: $primary;\n          background-color: $primary-light;\n        }\n        .icon-edit {\n          margin-right: 8px;\n        }\n        .view {\n          font-weight: 600;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
